import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Menu, Button, Tooltip } from 'antd';
import { 
  UploadOutlined, 
  DashboardOutlined, 
  ReloadOutlined,
  WifiOutlined,
  DisconnectOutlined,
  MonitorOutlined
} from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext';
import { getString } from '../utils/translations';

const Navigation = ({ socketConnected, onReconnect }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { organization, hasVideoProcessingWriteAccess } = useAuth();

  const menuItems = [
    ...(hasVideoProcessingWriteAccess ? [{
      key: '/upload',
      icon: <UploadOutlined />,
      label: getString('pipeline.nav.upload_videos', 'Upload Videos'),
    }] : []),
    {
      key: '/jobs',
      icon: <DashboardOutlined />,
      label: getString('pipeline.nav.job_dashboard', 'Job Dashboard'),
    },
    // Conditional monitoring access - only for organization ID = 1
    ...(organization?.id === 1 ? [{
      key: '/monitoring',
      icon: <MonitorOutlined />,
      label: getString('pipeline.nav.monitoring', 'Monitoring'),
    }] : []),
  ];

  const handleMenuClick = ({ key }) => {
    navigate(key);
  };

  return (
    <div className="navigation">
      <Menu
        mode="horizontal"
        selectedKeys={[location.pathname]}
        items={menuItems}
        onClick={handleMenuClick}
        disabledOverflow
        className="nav-menu"
      />
      
      {socketConnected && (
        <div className="connection-status">
          <Tooltip title={getString('pipeline.nav.real_time_updates_active', 'Real-time updates active')}>
            <div className="status-indicator-wrapper">
              <WifiOutlined style={{ color: '#52c41a' }} />
              <span style={{ marginLeft: '0.5rem' }}>
                {getString('pipeline.nav.connected', 'Connected')}
              </span>
            </div>
          </Tooltip>
        </div>
      )}
    </div>
  );
};

export default Navigation; 